import PropTypes from "prop-types"
import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material"
import TablePagination from "components/material/table-pagination"
import CoverageReportRow from "../coverage-report-row"

function CoverageReportTable({
  coverage,
  coveragePage,
  showCoveragePage,
  numberOfTableRows,
  model,
  showDate,
  downloadButton,
}) {
  return <>
    <div className="scan-preview-header">
      <div className="coverage-report-title"><strong>{model}</strong> coverage for <strong>{coverage.numberOfDates}</strong> dates found</div>
      {downloadButton}
    </div>
    <Table className="scan-preview-table">
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          {coverage.hasEquity && <TableCell align="right">Equity</TableCell>}
          {coverage.hasPnl && <TableCell align="right">P&L</TableCell>}
          <TableCell align="right">% Modeled</TableCell>
          <TableCell align="right">% Unmodeled</TableCell>
          <TableCell align="right">% Unmapped</TableCell>
          <TableCell align="right">Unmapped equities</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {coverage.dates.map((date, i) =>
          <CoverageReportRow key={i} showDate={showDate} date={date} hasEquity={coverage.hasEquity} hasPnl={coverage.hasPnl} />)}
      </TableBody>
    </Table>
    <TablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={coverage.numberOfDates}
      rowsPerPage={numberOfTableRows}
      page={coveragePage}
      onPageChange={showCoveragePage}
    />
  </>
}

CoverageReportTable.propTypes = {
  coverage: PropTypes.object.isRequired,
  coveragePage: PropTypes.number.isRequired,
  showCoveragePage: PropTypes.func.isRequired,
  numberOfTableRows: PropTypes.number.isRequired,
  model: PropTypes.string.isRequired,
  showDate: PropTypes.func.isRequired,
  downloadButton: PropTypes.element.isRequired,
}

export default CoverageReportTable
